/* SALITRE — global.js */
(function () {
  'use strict';

  /* ---------- Header: estado al hacer scroll ---------- */
  const header = document.querySelector('[data-header]');
  if (header && header.classList.contains('site-header--transparent')) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menú móvil ---------- */
  const burger = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (burger && mobileMenu) {
    burger.addEventListener('click', () => {
      if (header) mobileMenu.style.top = header.getBoundingClientRect().bottom + 'px';
      mobileMenu.classList.toggle('is-open');
    });
  }

  /* ---------- Enter page ---------- */
  const enterPage = document.getElementById('EnterPage');
  if (enterPage) {
    const once = enterPage.dataset.showOnce === 'true';
    if (once && sessionStorage.getItem('salitre:entered')) {
      enterPage.hidden = true;
    } else {
      document.body.style.overflow = 'hidden';
      enterPage.querySelector('[data-enter-page-close]').addEventListener('click', () => {
        enterPage.classList.add('is-closing');
        document.body.style.overflow = '';
        if (once) sessionStorage.setItem('salitre:entered', '1');
        setTimeout(() => { enterPage.hidden = true; }, 650);
      });
    }
  }

  /* ---------- Carrusel en tarjetas de producto ---------- */
  function initCard(card) {
    const slides = card.querySelectorAll('.card-product__slide');
    if (slides.length < 2) return;
    let index = 0;
    const show = (i) => {
      index = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
    };
    const prev = card.querySelector('[data-card-prev]');
    const next = card.querySelector('[data-card-next]');
    if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); show(index - 1); });
    if (next) next.addEventListener('click', (e) => { e.preventDefault(); show(index + 1); });
    card.addEventListener('mouseenter', () => { if (index === 0) show(1); });
    card.addEventListener('mouseleave', () => show(0));
  }
  function initAllCards(root) {
    (root || document).querySelectorAll('[data-card-product]').forEach(initCard);
  }
  initAllCards();

  /* ---------- Drag scroll (galerías y lookbook) ---------- */
  document.querySelectorAll('[data-drag-scroll]').forEach((track) => {
    let down = false, startX = 0, startScroll = 0;
    track.addEventListener('pointerdown', (e) => {
      down = true; startX = e.clientX; startScroll = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      track.scrollLeft = startScroll - (e.clientX - startX);
    });
    ['pointerup', 'pointercancel'].forEach((ev) =>
      track.addEventListener(ev, () => { down = false; track.classList.remove('is-dragging'); })
    );
  });

  /* ---------- Animaciones de aparición ---------- */
  if (document.body.classList.contains('animations-enabled')) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('[data-animate], .product__media').forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll('.product__media').forEach((el) => el.classList.add('is-visible'));
  }

  /* ---------- Scroll infinito en colecciones ---------- */
  const grid = document.querySelector('[data-product-grid]');
  const sentinel = document.querySelector('[data-infinite-sentinel]');
  if (grid && sentinel && sentinel.hasAttribute('data-active')) {
    let loading = false;
    const io = new IntersectionObserver(async (entries) => {
      const nextUrl = grid.dataset.nextUrl;
      if (!entries[0].isIntersecting || loading || !nextUrl) return;
      loading = true;
      try {
        const res = await fetch(nextUrl);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid) {
          newGrid.querySelectorAll('.card-product').forEach((card) => {
            grid.appendChild(card);
            initCard(card);
          });
          const newNext = newGrid.dataset.nextUrl;
          if (newNext) grid.dataset.nextUrl = newNext;
          else { delete grid.dataset.nextUrl; io.disconnect(); }
        }
      } catch (e) { /* red caída: reintento en el próximo cruce */ }
      loading = false;
    });
    io.observe(sentinel);
  }

  /* ---------- Ordenar colección ---------- */
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Carrito: drawer + AJAX ---------- */
  const drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function refreshDrawer() {
    const res = await fetch(window.location.pathname + '?sections=cart-drawer');
    const data = await res.json();
    const html = data['cart-drawer'];
    if (!html || !drawer) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    if (fresh) {
      drawer.innerHTML = fresh.innerHTML;
      bindDrawer();
    }
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
  }

  function bindDrawer() {
    if (!drawer) return;
    drawer.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeDrawer));
    drawer.querySelectorAll('[data-qty-change]').forEach((btn) =>
      btn.addEventListener('click', async () => {
        await fetch(window.routes.cart_change_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty) }),
        });
        await refreshDrawer();
        openDrawer();
      })
    );
  }
  bindDrawer();

  document.querySelectorAll('[data-cart-toggle]').forEach((el) =>
    el.addEventListener('click', (e) => {
      if (drawer) { e.preventDefault(); openDrawer(); }
    })
  );
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  /* Añadir al carrito sin recargar */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || !drawer) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        body: new FormData(form),
      });
      if (res.ok) {
        await refreshDrawer();
        openDrawer();
      }
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* ---------- Countdown (password page) ---------- */
  const cd = document.querySelector('[data-countdown]');
  if (cd) {
    const target = new Date(cd.dataset.countdown.replace(' ', 'T')).getTime();
    const pad = (n) => String(Math.max(0, n)).padStart(2, '0');
    const tick = () => {
      const diff = target - Date.now();
      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);
      cd.querySelector('[data-cd-days]').textContent = pad(days);
      cd.querySelector('[data-cd-hours]').textContent = pad(hours);
      cd.querySelector('[data-cd-mins]').textContent = pad(mins);
      cd.querySelector('[data-cd-secs]').textContent = pad(secs);
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ---------- Password page: mostrar login ---------- */
  const pwToggle = document.querySelector('[data-password-toggle]');
  const pwForm = document.querySelector('[data-password-form]');
  if (pwToggle && pwForm) {
    pwToggle.addEventListener('click', () => {
      pwForm.hidden = !pwForm.hidden;
      if (!pwForm.hidden) pwForm.querySelector('input').focus();
    });
  }
})();
